/* Couchmode product page: packs, per-hoodie colors, filtered gallery, sticky bar, delivery dates, lightbox */
(function () {
  'use strict';
  var root = document.querySelector('[data-cm-product]');
  if (!root) return;

  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

  var track = $('[data-track]');
  var frames = $$('.cm-frame');
  var thumbs = $$('.cm-thumb');
  var countEl = $('[data-count]');
  var packInputs = $$('input[name="cm-pack"]');
  var variantInput = $('[data-variant-id]');
  var colorSets = $$('.cm-colorpick');
  var priceNow = $('[data-price-now]');
  var priceWas = $('[data-price-was]');
  var priceSave = $('[data-price-save]');
  var atc = $('[data-atc]');
  var atcPrice = $('[data-atc-price]');
  var atcLabel = $('[data-atc-label]');
  var stickyPrice = $('[data-sticky-price]');
  var legend = $('[data-colors-legend] b');
  var touched = {};
  var currentColor = root.getAttribute('data-default-color') || 'Red';

  function visibleFrames() { return frames.filter(function (f) { return !f.hidden; }); }
  function visibleThumbs() { return thumbs.filter(function (t) { return !t.hidden; }); }

  /* ---------- Gallery ---------- */
  function updateCount() {
    var vf = visibleFrames();
    if (!vf.length) return;
    var w = track.clientWidth || 1;
    var idx = Math.round(track.scrollLeft / w);
    idx = Math.max(0, Math.min(vf.length - 1, idx));
    countEl.textContent = (idx + 1) + ' / ' + vf.length;
    visibleThumbs().forEach(function (t, i) {
      var b = t.querySelector('button');
      if (i === idx) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
  }
  function goTo(i) {
    var vf = visibleFrames();
    i = Math.max(0, Math.min(vf.length - 1, i));
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  }
  function showColor(color) {
    currentColor = color;
    var any = false;
    frames.forEach(function (f) { var on = f.getAttribute('data-color') === color; f.hidden = !on; any = any || on; });
    thumbs.forEach(function (t) { t.hidden = t.getAttribute('data-color') !== color; });
    if (!any) { frames.forEach(function (f) { f.hidden = false; }); thumbs.forEach(function (t) { t.hidden = false; }); }
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = 0;
    track.style.scrollBehavior = '';
    updateCount();
  }
  var scrollTick;
  track.addEventListener('scroll', function () { window.clearTimeout(scrollTick); scrollTick = window.setTimeout(updateCount, 60); }, { passive: true });
  thumbs.forEach(function (t) {
    t.querySelector('button').addEventListener('click', function () { goTo(visibleThumbs().indexOf(t)); });
  });
  var prev = $('[data-prev]'), next = $('[data-next]');
  if (prev) prev.addEventListener('click', function () { goTo(Math.round(track.scrollLeft / track.clientWidth) - 1); });
  if (next) next.addEventListener('click', function () { goTo(Math.round(track.scrollLeft / track.clientWidth) + 1); });
  window.addEventListener('resize', updateCount);

  /* ---------- Lightbox ---------- */
  var box = $('[data-lightbox]');
  var boxImg = $('[data-lightbox-img]');
  var boxIndex = 0;
  function openBox(i) {
    var vf = visibleFrames();
    if (!vf.length || !box || typeof box.showModal !== 'function') return;
    boxIndex = (i + vf.length) % vf.length;
    boxImg.src = vf[boxIndex].getAttribute('data-large');
    boxImg.alt = (vf[boxIndex].querySelector('img') || {}).alt || '';
    if (!box.open) box.showModal();
  }
  frames.forEach(function (f) {
    f.addEventListener('click', function () { openBox(visibleFrames().indexOf(f)); });
  });
  if (box) {
    $('[data-lightbox-close]').addEventListener('click', function () { box.close(); });
    $('[data-lightbox-prev]').addEventListener('click', function () { openBox(boxIndex - 1); });
    $('[data-lightbox-next]').addEventListener('click', function () { openBox(boxIndex + 1); });
    box.addEventListener('click', function (e) { if (e.target === box || e.target.classList.contains('cm-lightbox__inner')) box.close(); });
    box.addEventListener('close', function () { goTo(boxIndex); });
    document.addEventListener('keydown', function (e) {
      if (!box.open) return;
      if (e.key === 'ArrowLeft') openBox(boxIndex - 1);
      if (e.key === 'ArrowRight') openBox(boxIndex + 1);
    });
  }

  /* ---------- Packs ---------- */
  function selectedPack() { return packInputs.filter(function (i) { return i.checked; })[0] || packInputs[0]; }
  function unitColor(n) {
    var chosen = $('input[data-unit-input="' + n + '"]:checked');
    return chosen ? chosen.value : currentColor;
  }
  function applyPack() {
    var p = selectedPack();
    var units = parseInt(p.getAttribute('data-units'), 10) || 1;
    variantInput.value = p.value;
    priceNow.textContent = p.getAttribute('data-money');
    var hasCompare = p.getAttribute('data-has-compare') === 'true';
    priceWas.hidden = !hasCompare; priceSave.hidden = !hasCompare;
    priceWas.textContent = p.getAttribute('data-was');
    priceSave.textContent = 'Save ' + p.getAttribute('data-save');
    atcPrice.textContent = p.getAttribute('data-money');
    if (stickyPrice) stickyPrice.textContent = p.getAttribute('data-money');
    var available = p.getAttribute('data-available') !== 'false';
    atc.disabled = !available;
    atcLabel.textContent = available ? 'Add to cart' : 'Sold out';
    legend.textContent = units > 1 ? 'Choose a color for each hoodie' : 'Choose your color';

    colorSets.forEach(function (set) {
      var n = parseInt(set.getAttribute('data-unit'), 10);
      var show = n <= units;
      set.hidden = !show;
      $$('input', set).forEach(function (inp) { inp.disabled = !show; });
      if (show && n > 1 && !touched[n]) {
        var c = unitColor(1);
        var target = $('input[data-unit-input="' + n + '"][value="' + c + '"]');
        if (target) target.checked = true;
        $('[data-color-name]', set).textContent = c;
      }
    });
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', p.value);
      window.history.replaceState({}, '', url.toString());
    } catch (e) { /* ignore */ }
  }
  packInputs.forEach(function (i) { i.addEventListener('change', applyPack); });

  /* ---------- Colors ---------- */
  $$('input[data-unit-input]').forEach(function (inp) {
    inp.addEventListener('change', function () {
      var n = parseInt(inp.getAttribute('data-unit-input'), 10);
      var set = inp.closest('.cm-colorpick');
      $('[data-color-name]', set).textContent = inp.value;
      if (n === 1) {
        showColor(inp.value);
        var units = parseInt(selectedPack().getAttribute('data-units'), 10) || 1;
        for (var k = 2; k <= units; k++) {
          if (touched[k]) continue;
          var t = $('input[data-unit-input="' + k + '"][value="' + inp.value + '"]');
          if (t) { t.checked = true; $('[data-color-name]', t.closest('.cm-colorpick')).textContent = inp.value; }
        }
      } else {
        touched[n] = true;
      }
    });
  });

  /* ---------- URL params from homepage (?color=Navy&variant=123) ---------- */
  (function readParams() {
    try {
      var params = new URL(window.location.href).searchParams;
      var c = params.get('color');
      if (c) {
        var first = $('input[data-unit-input="1"][value="' + c + '"]');
        if (first) { first.checked = true; $('[data-color-name]', first.closest('.cm-colorpick')).textContent = c; showColor(c); }
      }
    } catch (e) { /* ignore */ }
  })();

  /* ---------- Delivery dates ---------- */
  (function delivery() {
    var el = $('[data-delivery-text]');
    var min = parseInt(root.getAttribute('data-delivery-min'), 10);
    var max = parseInt(root.getAttribute('data-delivery-max'), 10);
    var cutoff = root.getAttribute('data-cutoff');
    if (!el || !min || !max) return;
    function addBusinessDays(d, n) {
      var x = new Date(d.getTime()), added = 0;
      while (added < n) { x.setDate(x.getDate() + 1); var day = x.getDay(); if (day !== 0 && day !== 6) added++; }
      return x;
    }
    var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    var now = new Date();
    var text = 'Order today and get it between <b>' + fmt(addBusinessDays(now, min)) + '</b> and <b>' + fmt(addBusinessDays(now, max)) + '</b>';
    if (cutoff) text += '<br>' + cutoff.replace(/</g, '&lt;');
    el.innerHTML = text;
  })();

  /* ---------- Sticky add to cart (mobile) ---------- */
  (function sticky() {
    var bar = $('[data-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = bar.querySelector('button'); if (b) b.tabIndex = show ? 0 : -1;
      });
    }, { threshold: 0 });
    io.observe(atc);
  })();

  /* ---------- Init ---------- */
  var initial = selectedPack();
  if (initial) applyPack();
  showColor(currentColor);
})();